<template>
  <div class="tcgaExpAll">
    <a-row>
      <a-col :span="24"> <div id="boxplot"></div></a-col>
      <a-col :span="24">
        <a-input
          type="text"
          addon-before="Width : "
          addon-after="px"
          v-model="tWidth"
        />
        <br />
        <br />
        <a-input
          type="text"
          addon-before="Height: "
          addon-after="px"
          v-model="tHeight"
        />
      </a-col>
      <a-col :span="24" style="margin-top: 10px">
        <a-button type="primary" @click="changePlot()">Set options</a-button>
      </a-col>
    </a-row>
 
    <!-- <div style="text-align: center">
      <a-statistic
        title="Statistical significance"
        :value="112893"
        style="margin-right: 50px"
      />
    </div> -->
  </div>
</template>

<script>
import axios from "axios";
import Highcharts from "highcharts/highstock";
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsDrilldown from "highcharts/modules/drilldown";
import Highcharts3D from "highcharts/highcharts-3d";
import exporting from "highcharts/modules/exporting";

HighchartsMore(Highcharts);
HighchartsDrilldown(Highcharts);
Highcharts3D(Highcharts);
exporting(Highcharts);

export default {
  props: ["ensgId", "selectCa", "pvalue"],
  data() {
    return {
      tWidth: 750,
      tHeight: 400,
      pWidth: 750,
      pHeight: 400,
    };
  },
  watch: {
    pWidth() {
      //开始绘图
      axios
        .get(
          "http://research.gzsys.org.cn/perturbdb/API/TCGA/search_diffBoxplot.php",
          {
            params: {
              ensgId: this.ensgId,
            },
          }
        )
        .then((response) => {
          this.moreChart(
            response.data[this.selectCa]["xaxis"],
            response.data[this.selectCa]["yaxis"],
            this.selectCa,
            this.pvalue
          );
        });
    },
    pHeight() {
      //开始绘图
      axios
        .get(
          "http://research.gzsys.org.cn/perturbdb/API/TCGA/search_diffBoxplot.php",
          {
            params: {
              ensgId: this.ensgId,
            },
          }
        )
        .then((response) => {
          this.moreChart(
            response.data[this.selectCa]["xaxis"],
            response.data[this.selectCa]["yaxis"],
            this.selectCa,
            this.pvalue
          );
        });
    },
    selectCa() {
      //开始绘图
      axios
        .get(
          "http://research.gzsys.org.cn/perturbdb/API/TCGA/search_diffBoxplot.php",
          {
            params: {
              ensgId: this.ensgId,
            },
          }
        )
        .then((response) => {
          this.moreChart(
            response.data[this.selectCa]["xaxis"],
            response.data[this.selectCa]["yaxis"],
            this.selectCa,
            this.pvalue
          );
        });
    },
  },
  mounted() {
    //开始绘图
    axios
      .get(
        "http://research.gzsys.org.cn/perturbdb/API/TCGA/search_diffBoxplot.php",
        {
          params: {
            ensgId: this.ensgId,
          },
        }
      )
      .then((response) => {
        this.moreChart(
          response.data[this.selectCa]["xaxis"],
          response.data[this.selectCa]["yaxis"],
          this.selectCa,
          this.pvalue
        );
      });
  },
  methods: {
    changePlot() {
      // Assume default values for pWidth and pHeight, if necessary
      if (this.tWidth > 750) {
        this.pWidth = 750;
      } else if (this.tWidth < 400) {
        this.pWidth = 400;
      } else {
        this.pWidth = this.tWidth;
      }
      if (this.tHeight > 750) {
        this.pHeight = 750;
      } else if (this.tHeight < 400) {
        this.pHeight = 400;
      } else {
        this.pHeight = this.tHeight;
      }
    },
    moreChart(v1, v2, v3, v4) {
      if (this.chart) {
        this.chart.destroy();
      }
      // 初始化 Highcharts 图表
      this.chart = new Highcharts.chart("boxplot", {
        //去掉水印
        credits: {
          enabled: false,
        },
        chart: {
          type: "boxplot",
          // width: this.pWidth,
          // height: this.pHeight,
        },
        title: {
          text: "Expression of " + this.$route.query.gene + " in " + v3,
        },
        subtitle: {
          text: "P-value = " + v4,
          colors: "black",
        },
        legend: {
          enabled: false,
        },
        exporting: {
          filename: "Expression of " + this.$route.query.gene + " in " + v3,
          // chartOptions: {
          //   // specific options for the exported image
          //   chart: {
          sourceWidth: this.pWidth,
          sourceHeight: this.pHeight,
          scale: 1,
          //   },
          // },
        },
        // exporting: {
        //   width: v5,
        //   height: v6,
        //   scale: 1,
        //   // width: 200,
        //   filename: this.$route.query.gene + "_in_" + v3,
        // },
        xAxis: {
          categories: v1,
          labels: {
            useHTML: true, // 允许使用 HTML
          },
          lineColor: "black",
          lineWidth: 2,
          tickWidth: 2,
          tickLength: 5,
          tickColor: "black",
          crosshair: true,
          title: {
            text: "",
          },
        },
        yAxis: {
          title: {
            text: "Log2(TPM+1)",
          },
          tickWidth: 2,
          tickColor: "black",
          lineWidth: 2,
          lineColor: "black",
          tickLength: 5,
          gridLineColor: "white",
        },
        plotOptions: {
          boxplot: {
            colorByPoint: true,
            fillColor: null,
            colors: ["#4572a7", "#AA4643"],
            // lineWidth: 2,
            //中位线
            medianColor: "black",
            medianWidth: 1,
            medianDashStyle: "dashed",
            //连接线
            stemColor: "black",
            stemDashStyle: "dot",
            stemWidth: 1,
            //上下线
            whiskerColor: "black",
            whiskerLength: "20%",
            whiskerWidth: 2,
            groupPadding: 0.2,
            // pointWidth: 0.1,
          },
        },
        // tooltip: {
        //   pointFormat:
        //     '<span style="color:{};">\u25CF</span> <b> {series.name}</b><br>' + // eslint-disable-line no-dupe-keys
        //     "最大值: {point.high}<br>" +
        //     "Q2\t: {point.q3}<br>" +
        //     "中位数: {point.median}<br>" +
        //     "Q1\t: {point.q1}<br>" +
        //     "最小值: {point.low}<br>",
        // },

        series: [
          {
            name: "TPM",
            // stemColor: "black",
            lineColor: "black", // 设置外部线条颜色
            data: v2,
            tooltip: {
              headerFormat: "<em>{point.key}</em><br>",
            },
          },
        ],
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit css to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
